<template>
  <div
    class="mt-[25.87px]"
    :class="[noBottom ? '' : 'pb-[25.87px] border-b-[0.96px] border-[#E2E2E2]']"
  >
    <div class="flex items-center justify-start gap-[9.58px] mb-[23px]">
      <div class="bg-[#FFE9FB] rounded-full size-[42.16px] flex items-center justify-center">
        <span
          class="campaign-info-icon text-[23px]"
          :class="icon"
        />
      </div>
      <span class="text-[#000000] text-[15.33px] font-medium">{{ label }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'k-presention-chart',
    },
    noBottom: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.campaign-info-icon {
  background: linear-gradient(to bottom, #E04AB6, #F785D7);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
</style>
